import { UIStandardLayer } from "../BuildlingBlocks/UIStandardLayer";
import { OpenAIChatUI } from "./OpenAIChatUI";
import { OpenAIResponse } from "../../rule-engine-core/Plugins/OpenAPI/OpenAIResponse";
import { Box } from "@mui/material";

export function OpenAIChatLayer(props: {
    title: string;
    pretext?: string;
    posttext?: string;
    label?: string;
    initialPrompt?: string;
    priorConversation?: OpenAIResponse<string>;
    onSelectAnswer?: (answer: string) => void;
    onClose: () => void;
    open: boolean;
    needsClean?: (text: string) => boolean;
}) {
    return (
        <UIStandardLayer
            onClose={props.onClose}
            open={props.open}
            title={props.title}
            renderUI={() => {
                return (
                    <Box
                        width={"800px"}
                        height={"70vh"}
                    >
                        <OpenAIChatUI
                            pretext={props.pretext}
                            posttext={props.posttext}
                            label={props.label}
                            initialPrompt={props.initialPrompt}
                            priorConversation={props.priorConversation}
                            onSelectAnswer={props.onSelectAnswer}
                            needsClean={props.needsClean}
                        />
                    </Box>
                );
            }}
        />
    );
}
